import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faEdit,
  faTrash,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Profile.css";

function Profile({
  id,
  name,
  name_english,
  description,
  description_english,
  length,
  language,
}) {
  const { t } = useTranslation();

  return (
    <Row className="profile align-items-center">
      {language === "es" ? (
        <Col lg={11} className="profile-header">
          <Col className="profile-header-title">
            <h5>
              {name} - ({length})
            </h5>
          </Col>
          <Col className="profile-header-description">
            <h5>{description}</h5>
          </Col>
        </Col>
      ) : (
        <Col lg={11} className="profile-header">
          <Col className="profile-header-title">
            <h5>
              {name_english} - ({length})
            </h5>
          </Col>
          <Col className="profile-header-description">
            <h5>{description_english}</h5>
          </Col>
        </Col>
      )}
      <Col lg={1} className="profile-content">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            <FontAwesomeIcon icon={faCog} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item as={Link} to={`/profiles/succesors/${id}`}>
              <FontAwesomeIcon icon={faUsers} />{" "}
              {t("Perfiles.Perfil.Sucesores")}
            </Dropdown.Item>
            <Dropdown.Item as={Link} to={`/profiles/edit/${id}`}>
              <FontAwesomeIcon icon={faEdit} /> {t("Perfiles.Perfil.Editar")}
            </Dropdown.Item>
            <Dropdown.Item as={Link} to={`/profiles/delete/${id}`}>
              <FontAwesomeIcon icon={faTrash} /> {t("Perfiles.Perfil.Eliminar")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}

export default Profile;
